<template>
  <v-data-table
    :items="tickets"
    :headers="headers"
    :search="search"
    :loading="loading"
  >
    <template v-slot:item.name="{ item }">
      <v-btn
        rounded
        color="primary"
        :to="{ name: 'QualityRawDetail', params: { id: item.id } }"
      >
        <v-icon left>{{ item.nameIcon }}</v-icon>
        {{ item.name }}
      </v-btn>
    </template>
    <template v-slot:item.samples="{ item }">
      <v-badge>
        <template v-slot:badge>{{ item.samples }}</template>
        <v-icon>{{ item.samplesIcon }}</v-icon>
      </v-badge>
    </template>
    <template v-slot:item.rush="{ item }">
      <v-icon color="red darken-2" v-if="item.rush">{{ item.rushIcon }}</v-icon>
    </template>
    <template v-slot:item.id="{ item }">
      <QualityRawTicketForm
        :is-edit="true"
        :instance="item"
      />
    </template>
  </v-data-table>
</template>

<script>
import QualityRawTicketForm from "./QualityRawTicketForm";
export default {
  name: "QualityRawTicketsTable",
  components: { QualityRawTicketForm },
  props: {
    tickets: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    search: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      headers: [
        { text: "Name", sortable: true, value: "name" },
        { text: "Samples", sortable: true, value: "samples" },
        { text: "Rush", sortable: true, value: "rush" },
        { text: "Edit", sortable: false, value: "id" }
      ]
    };
  }
};
</script>
